import { INTERNAL_PATHS } from "routes/paths";

export const BREADCRUMB_PATHS = [
  {
    label: "Home",
    linkTo: INTERNAL_PATHS.HOME
  },
  {
    label: "Sell Gift Cards",
    linkTo: INTERNAL_PATHS.SELL_GIFT_CARDS
  }
];
